module.exports = __webpack_public_path__ + "static/media/recorrido15k.dd5e581a.webp";